import 'angular-ui-bootstrap';

var modalsModule =  angular.module('modals',['ui.bootstrap']);
export default modalsModule.name;